import React, { useEffect, useContext } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { ModalContext } from "../../../context/ModalContext";
import TermsPopup from "../../../Themes/Theme1/Popups/TermsPopup";
import myNextFoot from "../../../assets/images/nextDoor.svg";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};
const Footer = ({ store_data }) => {
  const { storeDetails } = useContext(GlobalContext);
  const [open, setOpen] = React.useState(false);
  const { isTermsOpen, handleTermsPopup } = useContext(ModalContext);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (
      window &&
      document &&
      storeDetails?.store?.storeDetails?.hubspot_portal_id &&
      storeDetails?.store?.storeDetails?.hubspot_form_id
    ) {
      const script = document.createElement("script");
      const body = document.getElementsByTagName("body")[0];
      script.src = "//js.hsforms.net/forms/v2.js";
      body.appendChild(script);
      script.addEventListener("load", () => {
        window.hbspt.forms.create({
          region: "na1",
          portalId: storeDetails?.store?.storeDetails?.hubspot_portal_id || "",
          formId: storeDetails?.store?.storeDetails?.hubspot_form_id || "",
          target: "#hubspotForm",
        });
      });
    }
  }, []);

  return (
    <footer>
      {/* <div className="bottomSec mb-5">
        <div className="container">
          <div className="bottoms">
            <div className="bottomcard">
              <h1>542+</h1>
              <h3>Lorem Ipsum</h3>
            </div>
            <div className="bottomcard">
              <h1>62</h1>
              <h3>Lorem Ipsum</h3>
            </div>
            <div className="bottomcard">
              <h1>62</h1>
              <h3>Lorem Ipsum</h3>
            </div>
            <div className="bottomcard">
              <h1>54M</h1>
              <h3>Lorem Ipsum</h3>
            </div>
          </div>
        </div>
      </div> */}
      <div className="footer">
        <div className="container">
          <div className="footerView d-flex justify-content-between align-items-start">
            <div className="footLogoCont">
              <img src={myNextFoot} alt="Logo" />
              <div className="footerTwo pt-3"></div>
              {/* <p className="supportInfo">(888) 905-5961</p> */}
              <p className="supportInfo">support@nextdoorauctions.com</p>
            </div>
            {/* <div className="footerTwo pt-4 d-flex align-items-center footSocialCent">
              <Link>
                <img src="/images/facebook.svg" />
              </Link>
              <Link>
                <img src="/images/youtube.svg" />
              </Link>
              <Link>
                <img src="/images/twitter.svg" />
              </Link>
            </div> */}
            <div className="footerTwo pt-4">
              <Link to="/faq">FAQs</Link>
              <Link to="/contact_us">Contact Us</Link>
              <Link to="/about_us">About Us</Link>
              {/* <Link to="" onClick={handleTermsPopup}>
                Terms Of Use
              </Link> */}
              <Link to="/termsofuse">Terms Of Use</Link>
              <Link to="/privacy_policies">Privacy Policy</Link>
            </div>
          </div>
          <div className="footerTwoMobview">
            <Link to="/faq">FAQs</Link>
            <Link to="/contact_us">Contact Us</Link>
            <Link to="/about_us">About Us</Link>
            {/* <Link to="" onClick={handleTermsPopup}>
              Terms Of Use
            </Link> */}
            <Link to="/termsofuse">Terms Of Use</Link>
            <Link to="/privacy_policies">Privacy Policy</Link>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center copy-right">
              <span> {new Date().getFullYear()} © NextDoor Auctions -</span>
              <span>&nbsp;All Rights Reserved&nbsp;&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
      {isTermsOpen && <TermsPopup />}
    </footer>
  );
};
export default Footer;
